import React, {Component} from "react";
import {connect} from "react-redux";
import {$shutils} from "../../../libs/snnh/snnh";
import {jsi} from "../../../index";
import MediaLike from "../buttons/media.like";
import {proxyBy} from "../../../modules/func";
import Visualizer from "./visualizer";

class PlayerMediaItem extends Component {
    current = 0;
    constructor(props) {
        super(props);

        const type = props.type || "media";
        this.default_image = `/images/img-rhymeduck${type === "recent" ? "" : "-w"}.png`;
        this.playCallback = props.playCallback;

        /**
         * @type {{
         *  type: string,
         *  data: DaoPlayerMedia
         * }}
         */
        this.state = {
            type,
            playing: jsi.jsi_is_play(),
            current_onair: props.current_onair || false,
            data: props.data
        };
    }

    componentDidUpdate(prevProps) {
        this.current = (this.props.current ? Math.ceil(this.props.current / 1000) : 0) || 0;
        try {
            /** @type {DaoPlayerMedia} */
            const n_media = this.props.data;
            /** @type {DaoPlayerMedia} */
            const p_media = prevProps.data;

            if(p_media.songid !== n_media.songid || this.props.type !== prevProps.type) {
                this.setState(prevState => {
                    /** @type {DaoPlayerMedia} */
                    const data = prevState.data;
                    Object.keys(n_media).forEach((key) => {
                        if(data.hasOwnProperty(key)) {
                            data[key] = n_media[key];
                        }
                    });
                    return  {data};
                })
            }
        } catch (e) {
        }
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    /**
     *
     * @returns {DaoPlayerMedia}
     */
    get data() {
        return this.state.data;
    }

    get stream() {
        return this.state.stream || {type: '', id: '', title: '', current: 0, duration: 0};
    }

    play(e) {
        e.stopPropagation();
        this.setState(
            { playing: !this.state.playing },
            () => {
                if(this.playCallback) this.playCallback.call(null, this.state.playing);
            }
        );
    }

    favoriteCallback(selected) {
        if(this.data) {
            this.data.favorite = selected ? 'Y' : 'N';
        }
    }

    get current_time() {
        return $shutils.toTime(Math.ceil(this.current || 0));
    }

    get total_time() {
        return $shutils.toTime(Math.ceil(this.data.playtime || 0));
    }

    get thumbnail() {
        return proxyBy(this.data.image || this.default_image);
    }

    get is_default() {
        return this.thumbnail === this.default_image;
    }

    get is_bgm() {
        return this.data.type === 'bgm';
    }

    error(e) {
        if (e) {
            e.target.src = this.default_image;
        }
    }

    render() {
        switch (this.state.type) {
            case "recent":
                return (
                    <div className="item">
                        <div className={`thumbnail ${this.is_default ? 'logo' : ''}`}>
                            {this.state.current_onair ? <Visualizer /> : null}
                            <span><img src={this.thumbnail} alt={this.data.songname} onError={this.error}/></span>
                        </div>
                        <div className="title-wrap">
                            <div className="title">
                                {this.state.current_onair ? <span className="current">지금 재생중</span> : null}
                                {this.data.songname}
                            </div>
                            <div className="artist">{this.data.artistname}</div>
                        </div>
                        <div className="like-wrap">
                            <MediaLike type={this.state.type}
                                       id={this.data.songid}
                                       selected={this.data.isFavorite}
                                       callback={this.favoriteCallback.bind(this)} />
                        </div>
                    </div>
                );
            case "media":
            default:
                return (
                    <div className="media-info">
                        <div className={`thumbnail${this.is_default ? '-logo' : ''}`}>
                            <span><img src={this.thumbnail} alt={this.data.songname} onError={this.error}/></span>
                        </div>
                        <div className={`title-wrap ${this.is_bgm ? '' : 'title-wrap2'}`}>
                            <div className="title">{this.data.songname}</div>
                            <div className="artist">{this.data.artistname}</div>
                        </div>

                        {
                            this.is_bgm ?
                                <div className="like-wrap">
                                    <MediaLike type={this.state.type}
                                               id={this.data.songid}
                                               selected={this.data.isFavorite}
                                               callback={this.favoriteCallback.bind(this)} />
                                </div> :
                                null
                        }

                        <div className="play-time">
                            <span className="current-time">{this.current_time}</span> / <span
                            className="total-time">{this.total_time}</span>
                        </div>

                        <div className="icon-play">
                            <span onClick={e => this.play(e)}><img src={`/images/${this.state.playing ? 'icon-false-type1' : 'icon-play-type1'}.png`} alt="재생/중지"/></span>
                        </div>
                    </div>
                );
        }
    }
}

export default connect()(PlayerMediaItem);


// WEBPACK FOOTER //
// ./src/pages/components/elements/player.media.item.jsx